import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";

interface AnalyticsPayload {
  assetCodes: string[];
  date: string;
}

const initialState: any = {
  motionData: [],
  isLoadingMotionVsTimeAnalytics: false,
  daylightData: [],
  isLoadingDaylightAnalytics: false,
  lightOPStatusData: [],
  isLoadingLightOPStatusAnalytics: false,
  error: null,
};

export const getAnalyticMotionData: any = createAsyncThunk(
  "analytics/getAnalyticMotionData",
  async (payload: AnalyticsPayload) => {
    const res = await axios.post(
      `/slpapp/Asset/getAnalyticMotionData`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    const data = await res.data;
    return data;
  },
);

export const getAnalyticDaylightData: any = createAsyncThunk(
  "analytics/getAnalyticDaylightData",
  async (payload: AnalyticsPayload) => {
    const res = await axios.post(
      `/slpapp/Asset/getAnalyticDaylightData`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    const data = await res.data;
    return data;
  },
);

export const getAnalyticLightOPStatusData: any = createAsyncThunk(
  "analytics/getAnalyticLightOPStatusData",
  async (payload: AnalyticsPayload) => {
    const res = await axios.post(
      `/slpapp/Asset/getAnalyticLightOPStatusData`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    const data = await res.data;
    return data;
  },
);

export const analyticsSlice = createSlice({
  name: "analytics",
  initialState,
  reducers: {
    resetMotionData(state) {
      state.motionData = [];
    },
    resetDaylightData(state) {
      state.daylightData = [];
    },
  },
  extraReducers: (builder) => {
    // Motion data cases
    builder.addCase(getAnalyticMotionData.pending, (state) => {
      state.isLoadingMotionVsTimeAnalytics = true;
      state.error = null;
    });
    builder.addCase(getAnalyticMotionData.fulfilled, (state, action) => {
      state.isLoadingMotionVsTimeAnalytics = false;
      state.motionData = action.payload;
    });
    builder.addCase(getAnalyticMotionData.rejected, (state, action) => {
      state.isLoadingMotionVsTimeAnalytics = false;
      state.error = action.error.message;
    });
    // Daylight data cases
    builder.addCase(getAnalyticDaylightData.pending, (state) => {
      state.isLoadingDaylightAnalytics = true;
      state.error = null;
    });
    builder.addCase(getAnalyticDaylightData.fulfilled, (state, action) => {
      state.isLoadingDaylightAnalytics = false;
      state.daylightData = action.payload;
    });
    builder.addCase(getAnalyticDaylightData.rejected, (state, action) => {
      state.isLoadingDaylightAnalytics = false;
      state.error = action.error.message;
    });
    // Light OP Status data cases
    builder.addCase(getAnalyticLightOPStatusData.pending, (state) => {
      state.isLoadingLightOPStatusAnalytics = true;
      state.error = null;
    });
    builder.addCase(getAnalyticLightOPStatusData.fulfilled, (state, action) => {
      state.isLoadingLightOPStatusAnalytics = false;
      state.lightOPStatusData = action.payload;
    });
    builder.addCase(getAnalyticLightOPStatusData.rejected, (state, action) => {
      state.isLoadingLightOPStatusAnalytics = false;
      state.error = action.error.message;
    });
  },
});

export const { resetMotionData, resetDaylightData } = analyticsSlice.actions;
export default analyticsSlice.reducer;
